import { useIntl } from "react-intl";

import Card from "components/v2/Card/Card";
import QuotationCard from "./QuotationCard/QuotationCard";
import { useGetQuotationConsts } from "../helpers/ShipmentQuotesV2Helpers";

interface QuotationListProps {
  quotations: any[];
}

export default function QuotationList({ quotations = [] }: QuotationListProps) {
  const intl = useIntl();
  const {
    showAlternativeQuotesButton,
    defaultQuotations,
    hasAtLeastOneRateCardQuote,
    quotationsRequireApproval,
    quoteTags,
    trafficLightBuckets,
  } = useGetQuotationConsts(quotations);

  const quotationCardProps = (quotation: any) => ({
    quotation,
    hasAtLeastOneRateCardQuote,
    quoteTags,
    trafficLightBuckets,
    quotationCount: quotations.length,
  });

  return (
    <div>
      {defaultQuotations.map((quote, index) => (
        <div key={index}>
          <QuotationCard {...quotationCardProps(quote)} />
          {index !== defaultQuotations.length - 1 && <div className="quotation-card-divider" />}
        </div>
      ))}

      {showAlternativeQuotesButton && (
        <div style={{ margin: "0 -24px" }}>
          <Card.Accordion
            containerClassName="justify-content-start px-2xl py-xl pb-0"
            accordionTitle={(isOpen) =>
              isOpen
                ? intl.formatMessage({
                    id: "shipment-quotes.components.quotes.hideAlernativeQuote",
                    defaultMessage: "Hide alternative quotes",
                  })
                : intl.formatMessage({
                    id: "shipment-quotes.components.quotes.showAlernativeQuote",
                    defaultMessage: "Show alternative quotes",
                  })
            }
          >
            {quotationsRequireApproval.map((quote, index) => (
              <div key={index} className="px-3xl">
                <div className="quotation-card-divider" />
                <QuotationCard {...quotationCardProps(quote)} />
              </div>
            ))}
          </Card.Accordion>
        </div>
      )}
    </div>
  );
}
